import React, {Component} from 'react';
import shortid from 'shortid';
import PropTypes from 'prop-types';
import {Row, Col, Alert} from 'react-bootstrap';

import {
	Code,
	Modal,
	Status,
	Table
} from '../../../../components/Other';
import {SuccessMessageTimeout} from '../../../../util/globals';
import LayoutPrivate from '../../../../components/Layout/Private';
import {
	formatTimestamp,
	handleChange,
	setTitle
} from '../../../../util/common';
import {
	Form,
	Select,
	Checkbox,
	Input
} from '../../../../components/Form';

class ListTimer extends Component {
	state = {
		success: false,
		deleteId: null,
		embed: null,
		embedSize: '',
		fullWidth: false,
		link: '',
		order: 'id',
		asc: false
	}

	componentDidMount() {
		setTitle(['Liczniki']);

		this.loadData(true);
	}

	componentDidUpdate(prevProps) {
		if (!prevProps.deleted && this.props.deleted) {
			this.props.listTimers(this.state.order, this.state.asc);

			this.setState({
				success: true
			}, () => {
				setTimeout(() => {
					this.setState({
						success: false
					});
				}, SuccessMessageTimeout);
			});
		}
	}

	sortable = (type) => {
		this.setState((prevState) => ({
			order: type,
			asc: prevState.order === type ? !prevState.asc : prevState.asc
		}), () => {
			this.loadData();
		});
	}

	loadData = (init = false) => {
		const {list, listTimers} = this.props;
		const {order, asc} = this.state;

		if (list) {
			if (list.order !== order || list.asc !== asc) {
				if (init) {
					this.setState({
						order: list.order,
						asc: list.asc
					});
				} else {
					listTimers(order, asc);
				}
			}
		} else {
			listTimers(order, asc);
		}
	}

	handleChange = (name, value) => handleChange(this, name, value);

	handleEmbed = (name) => {
		this.setState({
			embed: {
				name,
				uuid: shortid.generate()
			}
		});
	}

	handleEmbedClose = () => {
		this.setState({
			embed: null
		});
	}

	handleDelete = (deleteId) => {
		this.setState({
			deleteId
		});
	}

	handleDeleteConfirmed = () => {
		const {deleteTimer, loading} = this.props;
		const {deleteId} = this.state;

		if (loading) {
			return false;
		}

		this.setState({
			deleteId: null,
			success: false
		});

		deleteTimer(deleteId);

		return true;
	}

	handleDeleteClose = () => {
		this.setState({
			deleteId: null
		});
	}

	generateCode = () => {
		const {
			embed,
			link,
			fullWidth,
			embedSize
		} = this.state;

		if (link) {
			return `<div style="display: block; margin: auto; position: relative; width: ${fullWidth ? '100%; min-width: ' : ''}${embedSize}px; height: ${embedSize}px;"><iframe src="${process.env.REACT_APP_API_URL}/view/timer/${embed.name}/embed/${embed.uuid}" scrolling="no" class="smogalert" id="kas-smogalert-${embed.name}--${embed.uuid}" style="width: ${fullWidth ? '100%; min-width: ' : ''}${embedSize}px; height: ${embedSize}px; border: 0 none;"></iframe><a href="${link}" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"></a></div>`;
		}

		return `<iframe src="${process.env.REACT_APP_API_URL}/view/timer/${embed.name}/embed/${embed.uuid}" scrolling="no" class="smogalert" id="kas-smogalert-${embed.name}--${embed.uuid}" style="display: block; margin: auto; width: ${fullWidth ? '100%; min-width: ' : ''}${embedSize}px; height: ${embedSize}px; border: 0 none;"></iframe>`;
	}

	render() {
		const {
			list,
			history,
			loading,
			error
		} = this.props;

		const {
			success,
			deleteId,
			order,
			asc,
			embed,
			embedSize,
			fullWidth,
			link
		} = this.state;

		return (
			<LayoutPrivate>
				<Row>
					<Col>
						<h2 style={{marginBottom: '2rem'}}>Utworzone liczniki</h2>
						<Status
							success={success}
							error={error}
							loading={loading}
						/>
						<Table
							sortable={this.sortable}
							cols={[
								{
									sortable: true,
									name: 'id',
									label: '#'
								},
								{
									sortable: true,
									name: 'name',
									label: 'Nazwa'
								},
								{
									sortable: true,
									name: 'internal_name',
									label: 'Odnośnik',
									render: (item) => (
										<a
											href={`${process.env.REACT_APP_API_URL}/view/timer/${item.internal_name}`}
											className="link-secondary"
											target="_blank"
											rel="noreferrer"
										>
											{item.internal_name}
										</a>
									)
								},
								{
									sortable: true,
									name: 'updated',
									label: 'Zmieniono',
									render: (item) => (item.updated === item.created ? formatTimestamp(item.updated) : <em>{formatTimestamp(item.updated)}</em>)
								}
							]}
							order={order}
							asc={asc}
							operations={[
								{
									style: 'outline-primary',
									link: '/timer/add',
									label: 'Dodaj nowy licznik'
								}
							]}
							list={list ? list.list : null}
							actions={[
								{
									style: 'outline-secondary',
									action: (item) => this.handleEmbed(item.internal_name),
									label: 'Osadź'
								},
								{
									style: 'outline-success',
									action: (item) => history.push(`/timer/${item.id}`),
									label: 'Edytuj'
								},
								{
									style: 'outline-danger',
									action: (item) => this.handleDelete(item.id),
									label: 'Usuń'
								}
							]}
						/>
					</Col>
				</Row>
				{
					deleteId && (
						<Modal
							title="Potwierdź akcję"
							confirmAction={this.handleDeleteConfirmed}
							cancelAction={this.handleDeleteClose}
						>
							<p>
								Naprawdę chcesz usunąć licznik #{deleteId}? To spowoduje, że zniknie ona ze wszystkich miejsc, na których został umieszczona. Stanie się tak jakby nigdy nie istniał.
							</p>
							<Alert variant="warning">
								<strong>Zatrzymaj się na chwilę!</strong> Ta operacja jest nieodwracalna z poziomu panelu administratora. Może ją przywrócić tylko administrator systemu.
							</Alert>
						</Modal>
					)
				}
				{
					embed && (
						<Modal
							title="Kod osadzenia licznika"
							cancelText="Ok, to wszystko"
							cancelAction={this.handleEmbedClose}
						>
							<Alert variant="info">
								Skopiuj poniższy kod i wklej go na dowolnie wybranej przez siebie stronie w dowolnym miejscu.
							</Alert>
							<Alert variant="warning">
								Kod musi być skopiowany w całości, aby działał poprawnie!
							</Alert>
							<Form>
								<Select
									name="embedSize"
									value={embedSize}
									label="Wielkość widżetu"
									options={[
										{
											label: 'Wybierz wielkość widżetu',
											value: ''
										},
										{
											label: 'Bardzo mały (200x200px)',
											value: '200'
										},
										{
											label: 'Mały (300x300px)',
											value: '300'
										},
										{
											label: 'Średni (400x400px)',
											value: '400'
										},
										{
											label: 'Duży (500x500px)',
											value: '500'
										},
										{
											label: 'Bardzo duży (600x600px)',
											value: '600'
										},
										{
											label: 'Oblrzymi (700x700px)',
											value: '700'
										},
										{
											label: 'Gigantyczny (800x800px)',
											value: '800'
										}
									]}
									handleChange={this.handleChange}
								/>
								<Checkbox
									name="fullWidth"
									value={fullWidth}
									fieldLabel="Rozszerz widżet na całą szerokość"
									handleChange={this.handleChange}
								/>
								<p>
									<small>Po wybraniu tej opcji widżet nie będzie wyśrodkowanym kwadratem, a wolna przestrzeń po lewej i prawej stronie zostanie wykorzystana na margines wewnętrzny widżetu.</small>
								</p>
								<Input
									name="link"
									value={link}
									label="Odnośnik dla widżetu (opcjonalnie)"
									placeholder="Wpisz odnośnik dla widżetu (opcjonalnie)"
									handleChange={this.handleChange}
								/>
							</Form>
							{
								embedSize !== '' && (
									<>
										<hr />
										<Code
											code={this.generateCode()}
										/>
									</>
								)
							}
						</Modal>
					)
				}
			</LayoutPrivate>
		);
	}
}

ListTimer.propTypes = {
	history: PropTypes.object.isRequired,
	list: PropTypes.object,
	listTimers: PropTypes.func.isRequired,
	deleted: PropTypes.bool.isRequired,
	deleteTimer: PropTypes.func.isRequired,
	loading: PropTypes.bool.isRequired,
	error: PropTypes.bool.isRequired
};

ListTimer.defaultProps = {
	list: null
};

export default ListTimer;
